import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@apollo/client";
import { toast } from "react-toastify";
import { CREATE_MEASUREMENT_TECHNOLOGY_MUTATION } from "../../../../graphql/mutations";

const AddMeasurementTechModal = ({ show, handleClose, currentTenant, handleEnvChange, env }) => {
  const navigate = useNavigate();
  const [validationError, setValidationError] = useState("");

  const [formData, setFormData] = useState({
    name: "",
    description: ""
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));

    if (name === "name" && validationError) {
      setValidationError("");
    }
  };

  const resetForm = () => {
    setFormData({
      name: "",
      description: ""
    });
    setValidationError("");
  };

  const onModalClose = () => {
    resetForm();
    handleClose();
  };

  const validateForm = () => {
    if (!formData.name.trim()) {
      setValidationError("Name cannot be empty or contain only whitespace");
      return false;
    }
    return true;
  };

  const [createMeasurementTechnology, { loading: mutationLoading }] = useMutation(CREATE_MEASUREMENT_TECHNOLOGY_MUTATION);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // validate form before submitting
    if (!validateForm()) {
      return;
    }

    try {
      const { data } = await createMeasurementTechnology({
        variables: {
          measurementTechnology: {
            name: formData.name.trim(),
            description: formData.description
          }
        }
      });

      if (data?.createMeasurementTechnology) {
        onModalClose();
        setTimeout(() => {
          toast.success(`Measurement Technology: ${data?.createMeasurementTechnology.name} created successfully.`);
          navigate("/measurement-tech");
          handleEnvChange(env, currentTenant);
        }, 200);
      }
    } catch (error) {
      onModalClose();
      setTimeout(() => {
        toast.error("Failed to create measurement technology");
      }, 200);
    }
  };

  return (
    <Modal show={show} onHide={onModalClose} centered>
      <Modal.Header closeButton className="d-flex justify-content-center">
        <Modal.Title className="w-100 text-center">Add Measurement Technology</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit} noValidate>
          {/* Technology Name */}
          <Form.Group className="mb-3" controlId="formName">
            <Form.Label className="font-weight-bold">
              <strong>Name</strong>
            </Form.Label>
            <Form.Control
              type="text"
              name="name"
              value={formData.name}
              required
              onChange={handleInputChange}
              isInvalid={!!validationError}
            />
            <Form.Control.Feedback type="invalid">{validationError}</Form.Control.Feedback>
          </Form.Group>

          {/* Technology Description */}
          <Form.Group className="mb-3" controlId="formDescription">
            <Form.Label className="font-weight-bold">
              <strong>Description</strong>
            </Form.Label>
            <Form.Control
              as="textarea"
              rows={8}
              name="description"
              value={formData.description}
              onChange={handleInputChange}
              style={{ resize: "vertical" }}
            />
          </Form.Group>

          <div className="d-grid">
            <Button variant="primary" type="submit" style={{ width: "50%" }} className="mx-auto" disabled={mutationLoading}>
              {mutationLoading ? "Creating measurement technology..." : "Save"}
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export { AddMeasurementTechModal };
